//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
export function AdmissionPolicy(props) {
    return (
        <>
            <h2>Admission</h2>
            <p>Admission to the club is a right reserved to our members in good standing. You must present a valid photo ID for admission to parties. You are responsible for your actions at all times. Do not bring a disinterested partner or trick one into coming. All members (and their guests) must have a confirmed reservation in order to attend an event.</p>

            <h2>Illegal Substances</h2>
            <p>Members arriving to the club who are under the influence of or in possession of illicit substances will be denied admission to the event.</p>

            <h2>Alcohol</h2>
            <p>The Club is BYOB. During events alcohol is kept behind the bar labeled with your membership number and all drinks must be poured by the club's bartenders. There is no bottle service charge or pouring fees and the club provides cups, ice, soda, mixers and various juices free of charge.</p>
            <p>As an added membership benefit, VIP and Premium memberships can store their bottled alcohol safely behind the bar for use during future events. Alcohol for basic memberships will be given back when leaving the event.</p>
            <p>Intoxication is grounds for removal and loss of membership.</p>

            <h2>Dress Code</h2>
            <p>Inside, the dress code is &quot;Dress to impress&quot; sexy for the ladies and classy for the gents.  Costumes on theme nights are strongly encouraged, but never required. Lingerie, fetish gear, etc are always welcome.  We do not allow t-shirts, baseball caps, ripped or torn clothing, cut-off shorts, or sneakers during events unless explicitly stated. Not wearing club appropriate attire? We love nudity so come in and strip down!</p>
            <p>We provide changing rooms and ask that you arrive and leave the club discreetly.</p>

            <h2>Propositioning</h2>
            <p>Be respectful of your fellow members and always ask before touching.  If you are going to make or decline a proposition, do so in a respectful manner.  Remember, no means no.</p>

            <h2>Smoking</h2>
            <p>The entire club is non-smoking (vaping inside the club is also prohibited).</p>

            <h2>Cell Phones & Cameras</h2>
            <p>For the privacy of our membership - use of cell phones, cameras, and any other recording device is strictly prohibited within the Club.</p>

            <br/>
            <br/>

            <p>Any violation of these rules may result in the immediate termination of membership or expulsion from the club.</p>

            <p>Please review the <a href={process.env.PUBLIC_URL + '/pdf/agreement.pdf'}>membership agreement</a> for complete details.</p>
        </>
    );

}


